module.exports = __webpack_public_path__ + "img/2026-03-24b_1.2debdf2c.jpg";